// extracted by mini-css-extract-plugin
export default {"second-flow-container":"Flow_second-flow-container__V9lD6"};